// STORE DEPENDANCY
import { Action } from '@ngrx/store';

// COMMON INTERFACES
import { PopupNotification } from '../../../models/global/popup/popup-notification.interface';

/**
 * These action types are for dispatch in global reducer and for make api call in global service.
 * For global api call and store in global reducer purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially created POPUP_NOTIFICATION, FAILURE, EMPTY Actions
 */
export enum ActionTypes {
  // POPUP NOTIFICATION ACTIONS
  POPUP_NOTIFICATION = '[Global] Popup Notification',
  POPUP_NOTIFICATION_CALLBACK = '[Global] Popup Notification Callback',

  // FAILURE ACTIONS
  FAILURE = '[Global] Failure',

  // FAILURE ACTIONS
  EMPTY = '[Global] Empty',
}

// -------------------------------
//  Popup Notification
// -------------------------------
export class PopupNotificationAction implements Action {
  readonly type = ActionTypes.POPUP_NOTIFICATION;
  constructor(public popupNotification?: PopupNotification) { }
}

// -------------------------------
//  Popup Notification Callback
// -------------------------------
export class PopupNotificationCallbackAction implements Action {
  readonly type = ActionTypes.POPUP_NOTIFICATION_CALLBACK;
  constructor(public popupNotification?: PopupNotification) { }
}

// -------------------------------
//  Failure Notification
// -------------------------------
export class FailureAction implements Action {
  readonly type = ActionTypes.FAILURE;
  constructor(public payload: { type: string, error: string }) { }
}

// -------------------------------
//  Empty Action
// -------------------------------
export class EmptyAction implements Action {
  readonly type = ActionTypes.EMPTY;
  constructor(public empty: any) { }
}

export type Actions =
  | PopupNotificationAction
  | PopupNotificationCallbackAction
  | FailureAction
  | EmptyAction;
